"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataTypeAttribute = void 0;
const constants_1 = require("./constants");
const getDataTypeAttribute = ({ typeId, options: { showOnProd } = {} } = {}) => {
    if (!typeId) {
        return undefined;
    }
    if (!showOnProd && process.env.STAGE === constants_1.Stage.Prod) {
        return undefined;
    }
    return {
        'data-type-id': typeId,
    };
};
exports.getDataTypeAttribute = getDataTypeAttribute;
//# sourceMappingURL=testUtils.js.map